/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerAppResourceReadResponse
 */
export interface PlannerAppResourceReadResponse {
    /**
     * 
     * @type {string}
     * @memberof PlannerAppResourceReadResponse
     */
    uri: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerAppResourceReadResponse
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerAppResourceReadResponse
     */
    text: string;
    /**
     * 
     * @type {object}
     * @memberof PlannerAppResourceReadResponse
     */
    meta?: object | null;
}

/**
 * Check if a given object implements the PlannerAppResourceReadResponse interface.
 */
export function instanceOfPlannerAppResourceReadResponse(value: object): value is PlannerAppResourceReadResponse {
    if (!('uri' in value) || value['uri'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function PlannerAppResourceReadResponseFromJSON(json: any): PlannerAppResourceReadResponse {
    return PlannerAppResourceReadResponseFromJSONTyped(json, false);
}

export function PlannerAppResourceReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerAppResourceReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uri': json['uri'],
        'mimeType': json['mime_type'],
        'text': json['text'],
        'meta': json['meta'] == null ? undefined : json['meta'],
    };
}

export function PlannerAppResourceReadResponseToJSON(json: any): PlannerAppResourceReadResponse {
    return PlannerAppResourceReadResponseToJSONTyped(json, false);
}

export function PlannerAppResourceReadResponseToJSONTyped(value?: PlannerAppResourceReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uri': value['uri'],
        'mime_type': value['mimeType'],
        'text': value['text'],
        'meta': value['meta'],
    };
}

